import { useState, type FormEvent } from 'react'
import { Button, Field, Icon, Pill, Stack, Text } from '@/design-system'
import { AuthHeading } from './AuthForm'

const CORRIDORS = ['Mexico', 'Colombia', 'Brazil', 'Bolivia', 'United States']

export function WaitlistScreen() {
  const [joined, setJoined] = useState(false)

  function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setJoined(true)
  }

  if (joined) {
    return (
      <Stack gap={5} align="start">
        <Pill tone="accent">You&rsquo;re on the list</Pill>
        <AuthHeading
          title="We'll write when your corridor opens"
          subtitle="No marketing in between — one email, when there is something to open."
        />
        <Stack direction="row" align="center" gap={3}>
          <Icon name="schedule" size={20} />
          <Text variant="caption" tone="secondary">
            Most corridors open within a few weeks of reaching enough people.
          </Text>
        </Stack>
      </Stack>
    )
  }

  return (
    <Stack as="form" gap={6} onSubmit={handleSubmit}>
      <AuthHeading
        title="Join the waitlist"
        subtitle="We open one corridor at a time, so the payouts land in minutes rather than days."
      />

      <Stack gap={3}>
        <Field label="Email" type="email" autoComplete="email" placeholder="you@example.com" required />
        <Field label="Where do you send money?" placeholder={CORRIDORS.join(' · ')} />
      </Stack>

      <Button type="submit" size="lg" block>
        Join the waitlist
      </Button>

      <Text variant="caption" tone="secondary">
        One email when your corridor opens. Nothing else, and you can leave in a click.
      </Text>
    </Stack>
  )
}
